import React, {useEffect, useState} from "react"
import {useNavigate} from "react-router-dom"
import TitleBar, {MetaItemProps, TitleBarAction} from "../../components/TitleBar/TitleBar"
import {getApplicationActions} from "../../resources/applicationActions"
import {
	ApplicationDocument,
	ApplicationStatus,
	ApplicationType,
	ApplicationTypeIcons,
	evaluateApplicationLocation,
	IndividualApplication,
	isApplicationDocument,
	updateIndividualApplication,
	updateApplicationTags,
	ReasonCodes as ReasonCodesType,
	Sanctions,
	Pep,
	AdverseMediaMatches,
	DeviceFingerprints,
	convertReasonsToReasonCodes,
	IndividualSourceOfFunds,
	IndividualSourceOfFundsMapping,
	IndividualAccountPurpose,
	IndividualAccountPurposeMapping,
	IndividualTransactionVolume,
	IndividualTransactionVolumeMapping,
	SolePropTransactionVolume,
	SolePropTransactionVolumeMapping,
	BusinessSourceOfFunds,
	BusinessSourceOfFundsMapping,
	BusinessAccountPurpose,
	BusinessAccountPurposeMapping,
	reevaluableApplicationStatuses,
} from "../../resources/application"
import {useAccessToken, useIsOrgUser, useIsUnitComplianceUser, useIsUnitUser} from "../../services/auth"
import {MainSection} from "../../containers/MainSection/MainSection"
import {
	ApplicationStatusTag,
	AssigneeTag,
	CreatedAtTag,
	EvaluationOutcomeTag,
	Tags,
	UpdatedAtTag,
} from "../../components/Tag"
import ApplicationDocuments from "../../components/ApplicationDocuments/ApplicationDocuments"
import HorizontalField, {optionalHorizontalField} from "../../components/HorizontalField/HorizontalField"
import {
	Editable,
	EditableAddress,
	EditableDate,
	EditableFullName,
	EditableHiddenString,
	EditableOptionalString,
	EditablePhone,
	OptionalEditable,
	EditableYear,
} from "../../components/HorizontalField/EditableHorizontalField"
import {
	UnitOrBankUserOnly,
	AllowedToEvaluateUserOnly,
	AllowedToViewEvaluation,
} from "../../containers/PermissionedUser/PermissionedUser"
import {ApproveOnboardingApplicationModal} from "../../components/ApplicationApprove/OnboardingApplicationApprove"
import {CancelOnboardingApplicationModal} from "../../components/ApplicationCancel/OnboardingApplicationCancel"
import {CompletePendingModal} from "../../components/ApplicationCompletePending/ApplicationCompletePendingModal"
import {DenyOnboardingApplicationModal} from "../../components/ApplicationDeny/OnboardingApplicationDeny"
import {useModal} from "react-modal-hook"
import {OkDocument, Resource} from "../../resources/common"
import LinkButton from "../../components/LinkButton/LinkButton"
import {OnboardingApplicationDecision} from "../../components/ApplicationDecision/OnboardingApplicationDecision"
import {emailPreview} from "../../components/InformationHiding/InformationHiding"
import TagsCard from "../../components/Tags/TagsCard"
import {EvaluationFlags} from "../../components/EvaluationFlags/EvaluationFlags"
import {isUndefined} from "lodash"
import useAsyncResultIdle from "../../hooks/useAsyncResultIdle"
import {useToasts} from "react-toast-notifications"
import moment from "moment"
import {OnboardingIndividualRequestDocumentModal} from "../../components/RequestDocumentModal/OnboardingRequestDocumentModal"
import EvaluationScores from "../../components/EvaluationScores/EvaluationScores"
import IdentificationNumber, {
	getDocumentTitle,
	SSNProps,
} from "../../components/IdentificationNumber/IdentificationNumber"
import {OrgName} from "../../components/OrgName/OrgName"
import {HasPermission} from "../../containers/PermissionedUser/Permission"
import {EditableOccupationField} from "../../components/ApplicationAdditionalInformationFields/OccupationField"
import {EditableBusinessVerticalField} from "../../components/ApplicationAdditionalInformationFields/BusinessVerticalField"
import {EditableAnnualIncomeField} from "../../components/ApplicationAdditionalInformationFields/AnnualIncomeField"
import {EditableSolePropAnnualRevenueField} from "../../components/ApplicationAdditionalInformationFields/AnnualRevenueField"
import {EditableSolePropNumberOfEmployeesField} from "../../components/ApplicationAdditionalInformationFields/NumberOfEmployeesField"
import {Accordion} from "../../components/Accordion/Accordion"
import {EditableWebsiteField} from "../../components/EditableWebsiteField/EditableWebsiteField"
import {EditableSourceOfIncomeField} from "../../components/ApplicationAdditionalInformationFields/SourceOfIncomeField"
import {EditableIndividualSourceOfFundsField} from "../../components/ApplicationAdditionalInformationFields/IndividualSourceOfFundsField"
import {EditableIndividualAccountPurposeField} from "../../components/ApplicationAdditionalInformationFields/IndividualAccountPurposeField"
import {EditableIndividualTransactionVolumeField} from "../../components/ApplicationAdditionalInformationFields/IndividualTransactionVolumeField"
import {EditableSolePropTransactionVolumeField} from "../../components/ApplicationAdditionalInformationFields/SolePropTransactionVolumeField"
import {EditableProfessionField} from "../../components/ApplicationAdditionalInformationFields/ProfessionField"
import {EditableBusinessIndustryField} from "../../components/ApplicationAdditionalInformationFields/BusinessIndustryField"
import {EditableBusinessSourceOfFundsField} from "../../components/ApplicationAdditionalInformationFields/BusinessSourceOfFundsField"
import {EditableBusinessAccountPurposeField} from "../../components/ApplicationAdditionalInformationFields/BusinessAccountPurposeField"
import {EditableUsNexusField} from "../../components/ApplicationAdditionalInformationFields/UsNexusField"
import {EditableIsIncorporatedField} from "../../components/ApplicationAdditionalInformationFields/IsIncorporatedField"
import {CountriesOfOperation} from "../../components/ApplicationAdditionalInformationFields/CountriesOfOperation"
import {getAuditLogEventsHeaderMetaItems} from "../Applications/auditLogMetaItems"
import {isOrg, Org} from "../../resources/org"
import {useAuditLog} from "../../components/AuditLogDrawer/useAuditLog"
import AuditLogActionButton from "../../components/AuditLogActionButton/AuditLogActionButton"
import AuditLogDrawer from "../../components/AuditLogDrawer/AuditLogDrawer"
import Button from "../../components/Button/Button"
import ReevaluateButton from "../../components/ApplicationReevaluateButton/ReevaluateButton"
import CompletePendingButton from "../../components/ApplicationCompletePendingButton/CompletePendingButton"
import {hasPermission} from "../../services/permission"
import WatchlistMatches from "../../components/WatchlistMatches/WatchlistMatches"
import ReasonCodes from "../../components/ReasonCodes/ReasonCodes"
import {ApplicationDeviceInfo} from "../Applications/ApplicationPage"
import {OneProgramAdmonition} from "../../components/OneProgranAdmonition/OneProgramAdmonition"
import AIInsightsButton from "../../components/AIInsightsButton/AIInsightsButton"
import {isLocalEnv, isProdEnv} from "../../utilities/environment"
import {stateRegex} from "../../utilities/validation"
import {useLocalStorage} from "react-use"
import {AiInsights} from "../../components/AiInsights/AiInsights"
import {useListReturnPath} from "../../hooks/useListReturnPath"

function IndividualApplicationInternal({
	individual,
	documents,
	refresh,
	customEvaluationFlags,
	included,
}: {
	individual: IndividualApplication
	documents: ApplicationDocument[]
	refresh: () => void
	customEvaluationFlags: string[]
	included?: Resource[]
}) {
	const listReturnPath = useListReturnPath("/applications/")
	const accessToken = useAccessToken()
	const {addToast} = useToasts()
	const navigate = useNavigate()
	const [showApprove, hideApprove] = useModal(() => (
		<ApproveOnboardingApplicationModal close={hideApprove} application={individual} onSuccess={refresh} />
	))

	const [showDeny, hideDeny] = useModal(() => (
		<DenyOnboardingApplicationModal
			close={hideDeny}
			application={individual}
			onSuccess={refresh}
			accessToken={accessToken}
		/>
	))

	const [showCancel, hideCancel] = useModal(() => (
		<CancelOnboardingApplicationModal close={hideCancel} application={individual} onSuccess={refresh} />
	))

	const [showCompletePending, hideCompletePending] = useModal(() => (
		<CompletePendingModal close={hideCompletePending} application={individual} onSuccess={refresh} />
	))

	const [showRequestDocument, hideRequestDocument] = useModal(() => (
		<OnboardingIndividualRequestDocumentModal
			application={individual}
			close={hideRequestDocument}
			onSuccess={refresh}
		/>
	))

	const [isEditing, setIsEditing] = useState<string | undefined>(undefined)
	const [isUpdating, setIsUpdating] = useState(false)

	const {attributes} = individual
	const name = `${attributes.fullName.first} ${attributes.fullName.last}`

	let reasonCodes: ReasonCodesType | undefined
	const sanctions: Sanctions[] = individual.attributes.evaluation?.sanctions ?? []
	const pep: Pep[] = individual.attributes.evaluation?.pep ?? []
	const adverseMediaMatches: AdverseMediaMatches[] = individual.attributes.evaluation?.adverseMedia ?? []
	let deviceFingerprints: DeviceFingerprints | undefined

	if (individual.attributes.evaluation) {
		const forName = `${individual.attributes.fullName.first} ${individual.attributes.fullName.last}`
		reasonCodes = convertReasonsToReasonCodes(individual.attributes.evaluation?.reasonCodes)

		const matches: (Sanctions[] | Pep[] | AdverseMediaMatches[])[] = [sanctions, adverseMediaMatches, pep]
		matches.forEach((matches) => matches?.forEach((match) => (match.forNames = [{name: forName}])))

		deviceFingerprints = individual.attributes.evaluation.deviceFingerprints
	}

	const showWatchListMatches = sanctions.length || pep.length || adverseMediaMatches.length

	const documentTitle = getDocumentTitle(
		attributes.ssn,
		attributes.maskedSSN,
		attributes.passport,
		attributes.maskedPassport,
		attributes.matriculaConsular,
		attributes.maskedMatriculaConsular
	)
	const [fullName, setFullName] = useState(attributes.fullName)
	const [dob, setDob] = useState(attributes.dateOfBirth ? moment(attributes.dateOfBirth).toDate() : undefined)
	const [address, setAddress] = useState(attributes.address)
	const [phone, setPhone] = useState(attributes.phone)
	const [email, setEmail] = useState(attributes.email)
	const [ein, setEin] = useState(attributes.ein)
	const [dba, setDba] = useState(attributes.dba)
	const [updateState, updateApp] = useAsyncResultIdle(updateIndividualApplication)
	const [occupation, setOccupation] = useState(attributes.occupation)
	const [sourceOfIncome, setSourceOfIncome] = useState(attributes.sourceOfIncome)
	const [annualIncome, setAnnualIncome] = useState(attributes.annualIncome)
	const [numberOfEmployees, setNumberOfEmployees] = useState(attributes.numberOfEmployees)
	const [annualRevenue, setAnnualRevenue] = useState(attributes.annualRevenue)
	const [businessVertical, setBusinessVertical] = useState(attributes.businessVertical)
	const [website, setWebsite] = useState(attributes.website)
	const [individualSourceOfFunds, setIndividualSourceOfFunds] = useState(
		attributes.sourceOfFunds && IndividualSourceOfFundsMapping.has(attributes.sourceOfFunds)
			? (attributes.sourceOfFunds as IndividualSourceOfFunds)
			: undefined
	)
	const [individualAccountPurpose, setIndividualAccountPurpose] = useState(
		attributes.accountPurpose && IndividualAccountPurposeMapping.has(attributes.accountPurpose)
			? (attributes.accountPurpose as IndividualAccountPurpose)
			: undefined
	)
	const [individualTransactionVolume, setIndividualTransactionVolume] = useState(
		attributes.transactionVolume && IndividualTransactionVolumeMapping.has(attributes.transactionVolume)
			? (attributes.transactionVolume as IndividualTransactionVolume)
			: undefined
	)
	const [profession, setProfession] = useState(attributes.profession)
	const [sourceOfFundsDescription, setSourceOfFundsDescription] = useState(attributes.sourceOfFundsDescription)
	const [accountPurposeDetail, setAccountPurposeDetail] = useState(attributes.accountPurposeDetail)
	const [transactionVolumeDescription, setTransactionVolumeDescription] = useState(
		attributes.transactionVolumeDescription
	)
	const [businessIndustry, setBusinessIndustry] = useState(attributes.businessIndustry)
	const [businessSourceOfFunds, setBusinessSourceOfFunds] = useState(
		attributes.sourceOfFunds && BusinessSourceOfFundsMapping.has(attributes.sourceOfFunds)
			? (attributes.sourceOfFunds as BusinessSourceOfFunds)
			: undefined
	)
	const [businessAccountPurpose, setBusinessAccountPurpose] = useState(
		attributes.accountPurpose && BusinessAccountPurposeMapping.has(attributes.accountPurpose)
			? (attributes.accountPurpose as BusinessAccountPurpose)
			: undefined
	)
	const [solePropTransactionVolume, setSolePropTransactionVolume] = useState(
		attributes.transactionVolume && SolePropTransactionVolumeMapping.has(attributes.transactionVolume)
			? (attributes.transactionVolume as SolePropTransactionVolume)
			: undefined
	)
	const [usNexus, setUsNexus] = useState(attributes.usNexus)
	const [isIncorporated, setIsIncorporated] = useState(attributes.isIncorporated)
	const [stateOfIncorporation, setStateOfIncorporation] = useState(attributes.stateOfIncorporation)
	const [yearOfIncorporation, setYearOfIncorporation] = useState(attributes.yearOfIncorporation)
	const [businessDescription, setBusinessDescription] = useState(attributes.businessDescription)
	const hasNoWebsite = attributes.hasNoWebsite
	const archived = attributes.archived
	const isApplicationEditable =
		!archived && attributes.status !== ApplicationStatus.Canceled && attributes.status !== ApplicationStatus.Pending
	const isHiddenIconVisible = !useIsUnitComplianceUser()

	const {canApprove, canDeny, canCancel} = getApplicationActions(
		attributes.status,
		attributes.evaluationOutcome,
		archived
	)

	const canReevaluate = reevaluableApplicationStatuses.includes(attributes.status)

	const idTheftScore = attributes?.idTheftScore

	const evaluationScores = {
		...attributes.evaluationScores,
		...(idTheftScore ? {idTheftScore} : {}),
	}

	const org = included?.find((r) => isOrg(r) && r.id == individual.relationships.org.data.id) as unknown as Org

	const auditLogEventsHeaderMetaItems = getAuditLogEventsHeaderMetaItems({
		applicationName: name,
		applicationType: ApplicationType.individual,
		pageIcon: ApplicationTypeIcons[ApplicationType.individual],
		org: org as Org,
	})

	const handleResubmitNavigate = () => navigate(`/applications/${individual.id}/resubmit`)

	const {showAuditLog, openAuditLogDrawer, closeAuditLogDrawer, isAuditLogDrawerOpened} = useAuditLog()

	useEffect(() => {
		if (updateState.isOk()) {
			addToast("Application Updated Successfully", {appearance: "success"})
			setIsUpdating(false)
			refresh()
		} else if (updateState.isErr()) {
			addToast(updateState.error.errors[0].detail || updateState.error.errors[0].title, {appearance: "error"})
			setIsUpdating(false)
			refresh()
		}
	}, [updateState])

	const customerLink = individual.relationships.customer
		? `/customers/individual/${individual.relationships.customer.data.id}`
		: undefined

	const isUnitUser = useIsUnitUser()
	const [showAiButtonIndicatorLocalStorage, setShowAiButtonIndicatorLocalStorage] = useLocalStorage(
		"showAiButtonIndicator",
		"true"
	)

	const [showAiInsights, hideAiInsights] = useModal(() => (
		<AiInsights close={hideAiInsights} applicationId={individual.id} />
	))

	return (
		<>
			<TitleBar
				title={name}
				breadcrumbs={[{text: "Applications", path: listReturnPath}]}
				meta={[
					{text: "Individual", icon: "user-geometric-action---users"},
					...(customerLink
						? [
								{
									text: "Customer",
									icon: "user-geometric-action-money-fund---users",
									path: customerLink,
								} as MetaItemProps,
						  ]
						: []),
				]}
				status={
					attributes.archived
						? {
								text: "Archived",
								color: "#B0B2B5",
								backgroundColor: "#EBECEE",
						  }
						: undefined
				}
			>
				{showAuditLog && <AuditLogActionButton onClick={openAuditLogDrawer} />}
				<TitleBarAction>
					<ReevaluateButton
						application={individual}
						canReevaluate={canReevaluate}
						buttonOnClick={handleResubmitNavigate}
					/>
					<CompletePendingButton application={individual} buttonOnClick={showCompletePending} />
					<HasPermission resource="application.status.cancel" action="update">
						{canCancel && (
							<Button
								theme="danger"
								variant="outline"
								onClick={showCancel}
								prefixIcon="user-geometric-action-cross-remove"
							>
								<span>Cancel Application</span>
							</Button>
						)}
					</HasPermission>
				</TitleBarAction>
			</TitleBar>
			{org?.relationships?.parentOrg && <OneProgramAdmonition />}

			<MainSection>
				<AuditLogDrawer
					open={isAuditLogDrawerOpened}
					onClose={closeAuditLogDrawer}
					auditLogEventsHeaderMetaItems={auditLogEventsHeaderMetaItems}
					resourceType="application"
					resourceId={individual.id}
					showSubResourcesId={true}
				/>
				<div className="columns is-mobile">
					<div className="column is-narrow">
						<div className="buttons">
							{individual.attributes.evaluationEntityId ? (
								<LinkButton to={`https://unit.app.alloy.com/entities/${individual.attributes.evaluationEntityId}`}>
									Alloy
								</LinkButton>
							) : null}
						</div>
					</div>
					<div className="column">
						<AllowedToEvaluateUserOnly
							applicationOrgId={individual.relationships.org.data.id}
							assignee={individual.attributes.assignee}
						>
							<div className="buttons is-right">
								{false && (isLocalEnv() || isProdEnv()) && isUnitUser && (
									<AIInsightsButton
										onClick={() => {
											showAiInsights()
											setShowAiButtonIndicatorLocalStorage("false")
										}}
										className="mr-3"
										withIndicator={showAiButtonIndicatorLocalStorage === "true"}
									/>
								)}
								{attributes.status === ApplicationStatus.AwaitingDocuments ||
								attributes.status === ApplicationStatus.AwaitingInformation ||
								attributes.status === ApplicationStatus.PendingReview ? (
									<button
										className="button is-info"
										disabled={
											attributes.status !== ApplicationStatus.AwaitingDocuments &&
											attributes.status !== ApplicationStatus.AwaitingInformation &&
											attributes.status !== ApplicationStatus.PendingReview
										}
										onClick={() => showRequestDocument()}
									>
										Request Documents
									</button>
								) : null}

								<button className="button is-danger" disabled={!canDeny} onClick={() => showDeny()}>
									Deny
								</button>

								<button className="button is-success" disabled={!canApprove} onClick={() => showApprove()}>
									Approve
								</button>
							</div>
						</AllowedToEvaluateUserOnly>
					</div>
				</div>
				<div className="columns">
					<div className="column">
						<Tags>
							<CreatedAtTag createdAt={attributes.createdAt} />
							<UpdatedAtTag updatedAt={attributes.updatedAt} />
							{attributes.assignee ? <AssigneeTag assignee={attributes.assignee} /> : <React.Fragment />}
							<ApplicationStatusTag status={attributes.status} />
							<AllowedToViewEvaluation applicationOrgId={individual.relationships.org.data.id}>
								<EvaluationOutcomeTag value={attributes.evaluationOutcome} label="Individual Evaluation" />
							</AllowedToViewEvaluation>
						</Tags>
					</div>
				</div>

				<div className="columns">
					<div className="column is-4">
						<OnboardingApplicationDecision
							application={individual}
							fieldClassName={attributes.archived ? "archived-field" : ""}
						/>
						<div className="columns">
							<div className="column">
								<div className="card">
									<div className="card-header">
										<p className="card-header-title">Individual Information</p>
									</div>
									<div className="card-content">
										<UnitOrBankUserOnly>
											<HorizontalField label="Org">
												<OrgName orgId={individual.relationships.org.data.id} included={included} element={"span"} />
											</HorizontalField>

											<HorizontalField label="Application Id">
												<input type="text" className="input is-static" readOnly value={individual.id} />
											</HorizontalField>
										</UnitOrBankUserOnly>
										{individual.relationships.customer ? (
											<HorizontalField label="Customer Id" fieldClassName={attributes.archived ? "archived-field" : ""}>
												<input
													type="text"
													readOnly
													value={individual.relationships.customer.data.id}
													className="input is-static"
												/>
											</HorizontalField>
										) : null}
										<Editable
											label="Name"
											isEditing={isEditing === "Full Name"}
											isDisabled={!isUndefined(isEditing)}
											isAllowed={useIsUnitUser() && isApplicationEditable}
											isUpdating={isUpdating}
											onStartEdit={() => setIsEditing("Full Name")}
											onCancel={refresh}
											setValue={setFullName}
											value={fullName}
											initial={fullName}
											update={() => {
												updateApp(accessToken, individual, {fullName: fullName})
												setIsUpdating(true)
											}}
											className={attributes.archived ? "archived-field" : ""}
										>
											{EditableFullName}
										</Editable>
										<IdentificationNumber
											data={{
												initialSsn: {
													ssn: attributes.ssn ?? attributes.maskedSSN ?? "",
													nationality: attributes.nationality ?? "",
												},
												initialPassport: [
													attributes.nationality ?? "",
													attributes.passport ?? attributes.maskedPassport ?? "",
												],
												initialMatriculaConsular:
													attributes.matriculaConsular ?? attributes.maskedMatriculaConsular ?? "",
												documentTitle,
												archived,
											}}
											state={{
												isEditing,
												isEditable: isApplicationEditable,
												isUpdating,
												isHiddenIconVisible,
											}}
											actions={{
												setIsEditing,
												refresh,
												updateSSN: (ssnProps: SSNProps) =>
													updateApp(accessToken, individual, {
														ssn: ssnProps.ssn,
														nationality: ssnProps.nationality,
													}),
												updatePassport: (passport: [string, string]) =>
													updateApp(accessToken, individual, {
														passport: passport[1],
														nationality: passport[0],
													}),
												updateMatriculaConsular: (matriculaConsular: string) =>
													updateApp(accessToken, individual, {matriculaConsular}),
												setIsUpdating,
											}}
										/>
										<OptionalEditable
											label="Birth Date"
											isEditing={isEditing === "Birth Date"}
											isDisabled={!isUndefined(isEditing)}
											isAllowed={useIsUnitUser() && isApplicationEditable}
											isUpdating={isUpdating}
											isHiddenIconVisible={isHiddenIconVisible}
											onStartEdit={() => setIsEditing("Birth Date")}
											onCancel={refresh}
											setValue={setDob}
											value={dob}
											initial={dob}
											update={(v) => {
												updateApp(accessToken, individual, {dob: v})
												setIsUpdating(true)
											}}
											className={attributes.archived ? "archived-field" : ""}
										>
											{EditableDate}
										</OptionalEditable>
										<OptionalEditable
											label="Phone"
											isEditing={isEditing === "Phone"}
											isDisabled={!isUndefined(isEditing)}
											isAllowed={useIsUnitUser() && isApplicationEditable}
											isUpdating={isUpdating}
											isHiddenIconVisible={isHiddenIconVisible}
											onStartEdit={() => setIsEditing("Phone")}
											onCancel={refresh}
											setValue={setPhone}
											value={phone}
											initial={phone}
											update={() => {
												updateApp(accessToken, individual, {phone: phone})
												setIsUpdating(true)
											}}
											className={attributes.archived ? "archived-field" : ""}
										>
											{EditablePhone}
										</OptionalEditable>
										{optionalHorizontalField(
											"Phone Location ",
											attributes.phoneLocationDetails
												? Object.values(attributes.phoneLocationDetails)
														.filter((a) => a)
														.join(", ")
												: undefined,
											undefined,
											attributes.archived ? "archived-field" : ""
										)}
										{optionalHorizontalField(
											"IP Address",
											attributes.ip,
											undefined,
											attributes.archived ? "archived-field" : ""
										)}
										{optionalHorizontalField(
											"IP Location",
											attributes.ipLocationDetails
												? Object.values(attributes.ipLocationDetails)
														.filter((a) => a)
														.join(", ")
												: undefined,
											undefined,
											attributes.archived ? "archived-field" : ""
										)}
										<OptionalEditable
											label="Address"
											isEditing={isEditing === "Address"}
											isDisabled={!isUndefined(isEditing)}
											isAllowed={useIsUnitUser() && isApplicationEditable}
											isUpdating={isUpdating}
											onStartEdit={() => setIsEditing("Address")}
											onCancel={refresh}
											setValue={setAddress}
											value={address}
											initial={address}
											update={(v) => {
												updateApp(accessToken, individual, {address: v})
												setIsUpdating(true)
											}}
											className={attributes.archived ? "archived-field" : ""}
										>
											{EditableAddress}
										</OptionalEditable>
										<OptionalEditable
											label="Email"
											isEditing={isEditing === "Email"}
											isDisabled={!isUndefined(isEditing)}
											isAllowed={useIsUnitUser() && isApplicationEditable}
											isUpdating={isUpdating}
											isHiddenIconVisible={isHiddenIconVisible}
											onStartEdit={() => setIsEditing("Email")}
											onCancel={refresh}
											setValue={setEmail}
											value={email}
											initial={email}
											update={() => {
												updateApp(accessToken, individual, {email: email})
												setIsUpdating(true)
											}}
											inputType="email"
											previewFunction={emailPreview}
											className={attributes.archived ? "archived-field" : ""}
										>
											{EditableHiddenString}
										</OptionalEditable>
										<OptionalEditable
											label="EIN"
											isEditing={isEditing === "EIN"}
											isDisabled={!isUndefined(isEditing)}
											isAllowed={useIsUnitUser()}
											isUpdating={isUpdating}
											onStartEdit={() => setIsEditing("EIN")}
											onCancel={refresh}
											setValue={setEin}
											value={ein}
											initial={ein}
											update={() => {
												updateApp(accessToken, individual, {ein: ein})
												setIsUpdating(true)
											}}
											pattern="^\d{9}$"
										>
											{EditableHiddenString}
										</OptionalEditable>
										<Editable
											label="Doing Business As"
											isEditing={isEditing === "DBA"}
											isDisabled={!isUndefined(isEditing)}
											isAllowed={
												(useIsUnitUser() || (useIsOrgUser() && hasPermission("application", "update"))) &&
												isApplicationEditable
											}
											isUpdating={isUpdating}
											onStartEdit={() => setIsEditing("DBA")}
											onCancel={refresh}
											setValue={setDba}
											value={dba}
											initial={dba}
											update={() => {
												updateApp(accessToken, individual, {dba: dba})
												setIsUpdating(true)
											}}
											pattern={"^.*$"}
										>
											{EditableOptionalString}
										</Editable>
										{optionalHorizontalField(
											"Sole Proprietorship",
											attributes.soleProprietorship ? "Yes" : "No",
											undefined,
											attributes.archived ? "archived-field" : ""
										)}
										<Accordion title={"Additional Information"} theme={"light"}>
											<div>
												<EditableOccupationField
													occupation={occupation}
													setOccupation={setOccupation}
													isEditing={isEditing === "Occupation"}
													isDisabled={!isUndefined(isEditing)}
													isAllowed={
														(useIsUnitUser() || (useIsOrgUser() && hasPermission("application", "update"))) &&
														isApplicationEditable
													}
													onStartEdit={() => setIsEditing("Occupation")}
													onCancel={refresh}
													update={(v) => {
														updateApp(accessToken, individual, {occupation: v})
														setIsUpdating(true)
													}}
												/>
												<div>
													<EditableAnnualIncomeField
														annualIncome={annualIncome}
														setAnnualIncome={setAnnualIncome}
														isEditing={isEditing === "AnnualIncome"}
														isDisabled={!isUndefined(isEditing)}
														isAllowed={
															(useIsUnitUser() || (useIsOrgUser() && hasPermission("application", "update"))) &&
															isApplicationEditable
														}
														onStartEdit={() => setIsEditing("AnnualIncome")}
														onCancel={refresh}
														update={(v) => {
															updateApp(accessToken, individual, {annualIncome: v})
															setIsUpdating(true)
														}}
													/>
													<EditableSourceOfIncomeField
														sourceOfIncome={sourceOfIncome}
														setSourceOfIncome={setSourceOfIncome}
														isEditing={isEditing === "sourceOfIncome"}
														isDisabled={!isUndefined(isEditing)}
														isAllowed={
															(useIsUnitUser() || (useIsOrgUser() && hasPermission("application", "update"))) &&
															isApplicationEditable
														}
														onStartEdit={() => setIsEditing("sourceOfIncome")}
														onCancel={refresh}
														update={(v) => {
															updateApp(accessToken, individual, {sourceOfIncome: v})
															setIsUpdating(true)
														}}
													/>
												</div>
												<EditableBusinessVerticalField
													businessVertical={businessVertical}
													setBusinessVertical={setBusinessVertical}
													isEditing={isEditing === "BusinessVertical"}
													isDisabled={!isUndefined(isEditing)}
													isAllowed={
														(useIsUnitUser() || (useIsOrgUser() && hasPermission("application", "update"))) &&
														isApplicationEditable
													}
													onStartEdit={() => setIsEditing("BusinessVertical")}
													onCancel={refresh}
													update={(v) => {
														updateApp(accessToken, individual, {businessVertical: v})
														setIsUpdating(true)
													}}
												/>
												<EditableWebsiteField
													website={website}
													setWebsite={setWebsite}
													isEditing={isEditing === "Website"}
													onStartEdit={() => setIsEditing("Website")}
													onCancel={refresh}
													update={(v) => {
														updateApp(accessToken, individual, {website: v})
														setIsUpdating(true)
													}}
													isArchived={archived}
													isUpdating={isUpdating}
													isDisabled={!isUndefined(isEditing)}
													isAllowed={
														(useIsUnitUser() || (useIsOrgUser() && hasPermission("application", "update"))) &&
														isApplicationEditable
													}
													hasNoWebsite={hasNoWebsite}
												/>

												<EditableSolePropNumberOfEmployeesField
													numberOfEmployees={numberOfEmployees}
													setNumberOfEmployees={setNumberOfEmployees}
													isEditing={isEditing === "NumberOfEmployees"}
													isDisabled={!isUndefined(isEditing)}
													isAllowed={
														(useIsUnitUser() || (useIsOrgUser() && hasPermission("application", "update"))) &&
														isApplicationEditable
													}
													onStartEdit={() => setIsEditing("NumberOfEmployees")}
													onCancel={refresh}
													update={(v) => {
														updateApp(accessToken, individual, {numberOfEmployees: v})
														setIsUpdating(true)
													}}
												/>
												<EditableSolePropAnnualRevenueField
													annualRevenue={annualRevenue}
													setAnnualRevenue={setAnnualRevenue}
													isEditing={isEditing === "AnnualRevenue"}
													isDisabled={!isUndefined(isEditing)}
													isAllowed={
														(useIsUnitUser() || (useIsOrgUser() && hasPermission("application", "update"))) &&
														isApplicationEditable
													}
													onStartEdit={() => setIsEditing("AnnualRevenue")}
													onCancel={refresh}
													update={(v) => {
														updateApp(accessToken, individual, {annualRevenue: v})
														setIsUpdating(true)
													}}
												/>

												{!attributes.soleProprietorship && (
													<>
														<EditableIndividualSourceOfFundsField
															sourceOfFunds={individualSourceOfFunds}
															setSourceOfFunds={setIndividualSourceOfFunds}
															isEditing={isEditing === "IndividualSourceOfFunds"}
															isDisabled={!isUndefined(isEditing)}
															isAllowed={
																(useIsUnitUser() || (useIsOrgUser() && hasPermission("application", "update"))) &&
																isApplicationEditable
															}
															onStartEdit={() => setIsEditing("IndividualSourceOfFunds")}
															onCancel={refresh}
															update={(v) => {
																updateApp(accessToken, individual, {sourceOfFunds: v})
																setIsUpdating(true)
															}}
														/>
														<OptionalEditable
															label="Source of Funds Description"
															isEditing={isEditing === "SourceOfFundsDescription"}
															isDisabled={!isUndefined(isEditing)}
															isAllowed={
																(useIsUnitUser() || (useIsOrgUser() && hasPermission("application", "update"))) &&
																isApplicationEditable
															}
															isUpdating={isUpdating}
															onStartEdit={() => setIsEditing("SourceOfFundsDescription")}
															onCancel={refresh}
															setValue={setSourceOfFundsDescription}
															value={sourceOfFundsDescription}
															initial={sourceOfFundsDescription}
															update={() => {
																updateApp(accessToken, individual, {
																	sourceOfFundsDescription: sourceOfFundsDescription,
																})
																setIsUpdating(true)
															}}
														>
															{EditableOptionalString}
														</OptionalEditable>
														<EditableIndividualAccountPurposeField
															accountPurpose={individualAccountPurpose}
															setAccountPurpose={setIndividualAccountPurpose}
															isEditing={isEditing === "IndividualAccountPurpose"}
															isDisabled={!isUndefined(isEditing)}
															isAllowed={
																(useIsUnitUser() || (useIsOrgUser() && hasPermission("application", "update"))) &&
																isApplicationEditable
															}
															onStartEdit={() => setIsEditing("IndividualAccountPurpose")}
															onCancel={refresh}
															update={(v) => {
																updateApp(accessToken, individual, {accountPurpose: v})
																setIsUpdating(true)
															}}
														/>
														<OptionalEditable
															label="Account Purpose Detail"
															isEditing={isEditing === "AccountPurposeDetail"}
															isDisabled={!isUndefined(isEditing)}
															isAllowed={
																(useIsUnitUser() || (useIsOrgUser() && hasPermission("application", "update"))) &&
																isApplicationEditable
															}
															isUpdating={isUpdating}
															onStartEdit={() => setIsEditing("AccountPurposeDetail")}
															onCancel={refresh}
															setValue={setAccountPurposeDetail}
															value={accountPurposeDetail}
															initial={accountPurposeDetail}
															update={() => {
																updateApp(accessToken, individual, {
																	accountPurposeDetail: accountPurposeDetail,
																})
																setIsUpdating(true)
															}}
														>
															{EditableOptionalString}
														</OptionalEditable>
														<EditableIndividualTransactionVolumeField
															transactionVolume={individualTransactionVolume}
															setTransactionVolume={setIndividualTransactionVolume}
															isEditing={isEditing === "IndividualTransactionVolume"}
															isDisabled={!isUndefined(isEditing)}
															isAllowed={
																(useIsUnitUser() || (useIsOrgUser() && hasPermission("application", "update"))) &&
																isApplicationEditable
															}
															onStartEdit={() => setIsEditing("IndividualTransactionVolume")}
															onCancel={refresh}
															update={(v) => {
																updateApp(accessToken, individual, {transactionVolume: v})
																setIsUpdating(true)
															}}
														/>
														<OptionalEditable
															label="Transaction Volume Description"
															isEditing={isEditing === "TransactionVolumeDescription"}
															isDisabled={!isUndefined(isEditing)}
															isAllowed={
																(useIsUnitUser() || (useIsOrgUser() && hasPermission("application", "update"))) &&
																isApplicationEditable
															}
															isUpdating={isUpdating}
															onStartEdit={() => setIsEditing("TransactionVolumeDescription")}
															onCancel={refresh}
															setValue={setTransactionVolumeDescription}
															value={transactionVolumeDescription}
															initial={transactionVolumeDescription}
															update={() => {
																updateApp(accessToken, individual, {
																	transactionVolumeDescription: transactionVolumeDescription,
																})
																setIsUpdating(true)
															}}
														>
															{EditableOptionalString}
														</OptionalEditable>
														<EditableProfessionField
															profession={profession}
															setProfession={setProfession}
															isEditing={isEditing === "Profession"}
															isDisabled={!isUndefined(isEditing)}
															isAllowed={
																(useIsUnitUser() || (useIsOrgUser() && hasPermission("application", "update"))) &&
																isApplicationEditable
															}
															onStartEdit={() => setIsEditing("Profession")}
															onCancel={refresh}
															update={(v) => {
																updateApp(accessToken, individual, {profession: v})
																setIsUpdating(true)
															}}
														/>
													</>
												)}

												{attributes.soleProprietorship && (
													<>
														<EditableBusinessIndustryField
															businessIndustry={businessIndustry}
															setBusinessIndustry={setBusinessIndustry}
															isEditing={isEditing === "BusinessIndustry"}
															isDisabled={!isUndefined(isEditing)}
															isAllowed={
																(useIsUnitUser() || (useIsOrgUser() && hasPermission("application", "update"))) &&
																isApplicationEditable
															}
															onStartEdit={() => setIsEditing("BusinessIndustry")}
															onCancel={refresh}
															update={(v) => {
																updateApp(accessToken, individual, {businessIndustry: v})
																setIsUpdating(true)
															}}
														/>
														<EditableBusinessSourceOfFundsField
															sourceOfFunds={businessSourceOfFunds}
															setSourceOfFunds={setBusinessSourceOfFunds}
															isEditing={isEditing === "BusinessSourceOfFunds"}
															isDisabled={!isUndefined(isEditing)}
															isAllowed={
																(useIsUnitUser() || (useIsOrgUser() && hasPermission("application", "update"))) &&
																isApplicationEditable
															}
															onStartEdit={() => setIsEditing("BusinessSourceOfFunds")}
															onCancel={refresh}
															update={(v) => {
																updateApp(accessToken, individual, {sourceOfFunds: v})
																setIsUpdating(true)
															}}
														/>
														<OptionalEditable
															label="Source of Funds Description"
															isEditing={isEditing === "SourceOfFundsDescriptionSoleProp"}
															isDisabled={!isUndefined(isEditing)}
															isAllowed={
																(useIsUnitUser() || (useIsOrgUser() && hasPermission("application", "update"))) &&
																isApplicationEditable
															}
															isUpdating={isUpdating}
															onStartEdit={() => setIsEditing("SourceOfFundsDescriptionSoleProp")}
															onCancel={refresh}
															setValue={setSourceOfFundsDescription}
															value={sourceOfFundsDescription}
															initial={sourceOfFundsDescription}
															update={() => {
																updateApp(accessToken, individual, {
																	sourceOfFundsDescription: sourceOfFundsDescription,
																})
																setIsUpdating(true)
															}}
														>
															{EditableOptionalString}
														</OptionalEditable>
														<EditableBusinessAccountPurposeField
															accountPurpose={businessAccountPurpose}
															setAccountPurpose={setBusinessAccountPurpose}
															isEditing={isEditing === "BusinessAccountPurpose"}
															isDisabled={!isUndefined(isEditing)}
															isAllowed={
																(useIsUnitUser() || (useIsOrgUser() && hasPermission("application", "update"))) &&
																isApplicationEditable
															}
															onStartEdit={() => setIsEditing("BusinessAccountPurpose")}
															onCancel={refresh}
															update={(v) => {
																updateApp(accessToken, individual, {accountPurpose: v})
																setIsUpdating(true)
															}}
														/>
														<OptionalEditable
															label="Account Purpose Detail"
															isEditing={isEditing === "AccountPurposeDetailSoleProp"}
															isDisabled={!isUndefined(isEditing)}
															isAllowed={
																(useIsUnitUser() || (useIsOrgUser() && hasPermission("application", "update"))) &&
																isApplicationEditable
															}
															isUpdating={isUpdating}
															onStartEdit={() => setIsEditing("AccountPurposeDetailSoleProp")}
															onCancel={refresh}
															setValue={setAccountPurposeDetail}
															value={accountPurposeDetail}
															initial={accountPurposeDetail}
															update={() => {
																updateApp(accessToken, individual, {
																	accountPurposeDetail: accountPurposeDetail,
																})
																setIsUpdating(true)
															}}
														>
															{EditableOptionalString}
														</OptionalEditable>
														<EditableSolePropTransactionVolumeField
															transactionVolume={solePropTransactionVolume}
															setTransactionVolume={setSolePropTransactionVolume}
															isEditing={isEditing === "SolePropTransactionVolume"}
															isDisabled={!isUndefined(isEditing)}
															isAllowed={
																(useIsUnitUser() || (useIsOrgUser() && hasPermission("application", "update"))) &&
																isApplicationEditable
															}
															onStartEdit={() => setIsEditing("SolePropTransactionVolume")}
															onCancel={refresh}
															update={(v) => {
																updateApp(accessToken, individual, {transactionVolume: v})
																setIsUpdating(true)
															}}
														/>
														<OptionalEditable
															label="Transaction Volume Description"
															isEditing={isEditing === "TransactionVolumeDescriptionSoleProp"}
															isDisabled={!isUndefined(isEditing)}
															isAllowed={
																(useIsUnitUser() || (useIsOrgUser() && hasPermission("application", "update"))) &&
																isApplicationEditable
															}
															isUpdating={isUpdating}
															onStartEdit={() => setIsEditing("TransactionVolumeDescriptionSoleProp")}
															onCancel={refresh}
															setValue={setTransactionVolumeDescription}
															value={transactionVolumeDescription}
															initial={transactionVolumeDescription}
															update={() => {
																updateApp(accessToken, individual, {
																	transactionVolumeDescription: transactionVolumeDescription,
																})
																setIsUpdating(true)
															}}
														>
															{EditableOptionalString}
														</OptionalEditable>
														<EditableIsIncorporatedField
															isIncorporated={isIncorporated}
															setIsIncorporated={setIsIncorporated}
															isEditing={isEditing === "IsIncorporated"}
															isDisabled={!isUndefined(isEditing)}
															isAllowed={
																(useIsUnitUser() || (useIsOrgUser() && hasPermission("application", "update"))) &&
																isApplicationEditable
															}
															isUpdating={isUpdating}
															onStartEdit={() => setIsEditing("IsIncorporated")}
															onCancel={refresh}
															update={(v) => {
																updateApp(accessToken, individual, {isIncorporated: v})
																setIsUpdating(true)
															}}
														/>
														<OptionalEditable
															label="State of Incorporation"
															isEditing={isEditing === "StateOfIncorporation"}
															isDisabled={!isUndefined(isEditing)}
															isAllowed={
																(useIsUnitUser() || (useIsOrgUser() && hasPermission("application", "update"))) &&
																isApplicationEditable
															}
															isUpdating={isUpdating}
															onStartEdit={() => setIsEditing("StateOfIncorporation")}
															onCancel={refresh}
															setValue={setStateOfIncorporation}
															value={stateOfIncorporation}
															initial={stateOfIncorporation}
															update={() => {
																updateApp(accessToken, individual, {
																	stateOfIncorporation: stateOfIncorporation,
																})
																setIsUpdating(true)
															}}
															pattern={stateRegex}
														>
															{EditableOptionalString}
														</OptionalEditable>
														<OptionalEditable
															label="Year of Incorporation"
															isEditing={isEditing === "YearOfIncorporation"}
															isDisabled={!isUndefined(isEditing)}
															isAllowed={
																(useIsUnitUser() || (useIsOrgUser() && hasPermission("application", "update"))) &&
																isApplicationEditable
															}
															onStartEdit={() => setIsEditing("YearOfIncorporation")}
															onCancel={refresh}
															setValue={setYearOfIncorporation}
															value={yearOfIncorporation}
															initial={yearOfIncorporation}
															update={(v) => {
																updateApp(accessToken, individual, {yearOfIncorporation: v})
																setIsUpdating(true)
															}}
														>
															{EditableYear}
														</OptionalEditable>
														<CountriesOfOperation
															countriesOfOperation={attributes.countriesOfOperation}
															isArchived={archived}
														/>
														<EditableUsNexusField
															usNexus={usNexus}
															setUsNexus={setUsNexus}
															isEditing={isEditing === "UsNexus"}
															isDisabled={!isUndefined(isEditing)}
															isAllowed={
																(useIsUnitUser() || (useIsOrgUser() && hasPermission("application", "update"))) &&
																isApplicationEditable
															}
															isUpdating={isUpdating}
															onStartEdit={() => setIsEditing("UsNexus")}
															onCancel={refresh}
															update={(v) => {
																updateApp(accessToken, individual, {usNexus: v})
																setIsUpdating(true)
															}}
														/>
														<OptionalEditable
															label="Business Description"
															isEditing={isEditing === "BusinessDescription"}
															isDisabled={!isUndefined(isEditing)}
															isAllowed={
																(useIsUnitUser() || (useIsOrgUser() && hasPermission("application", "update"))) &&
																isApplicationEditable
															}
															isUpdating={isUpdating}
															onStartEdit={() => setIsEditing("BusinessDescription")}
															onCancel={refresh}
															setValue={setBusinessDescription}
															value={businessDescription}
															initial={businessDescription}
															update={() => {
																updateApp(accessToken, individual, {
																	businessDescription: businessDescription,
																})
																setIsUpdating(true)
															}}
														>
															{EditableOptionalString}
														</OptionalEditable>
													</>
												)}
											</div>
										</Accordion>
									</div>
								</div>
								{deviceFingerprints && ApplicationDeviceInfo(deviceFingerprints)}
							</div>
						</div>
						<div className="columns">
							<div className="column">
								<TagsCard
									tags={attributes.tags}
									onUpdateTags={(token, tags) => updateApplicationTags(token, individual.id, individual.type, tags)}
									refresh={refresh}
									editable={hasPermission("application", "update")}
								/>
							</div>
						</div>
					</div>
					<div className="column">
						<div className="columns">
							<div className="column">
								<div className="card has-full-height">
									<div className="card-header">
										<p className="card-header-title">Evaluation Flags</p>
									</div>
									<div className="card-content">
										<EvaluationFlags
											title="Individual"
											flags={attributes.evaluationFlags?.concat(customEvaluationFlags)}
										/>
									</div>
								</div>
							</div>

							{evaluationScores && Object.keys(Object.keys(evaluationScores)).length > 0 ? (
								<div className="column">
									<div className="card">
										<div className="card-header">
											<p className="card-header-title">Evaluation Scores</p>
										</div>
										<div className="card-content">
											<EvaluationScores scores={evaluationScores} />
										</div>
									</div>
								</div>
							) : null}
						</div>

						<ApplicationDocuments application={individual} documents={documents} refresh={refresh} />

						{showWatchListMatches > 0 && (
							<WatchlistMatches sanctions={sanctions} pep={pep} adverseMediaMatches={adverseMediaMatches} />
						)}

						{reasonCodes ? <ReasonCodes data={[{name, items: reasonCodes}]} /> : null}
					</div>
				</div>
			</MainSection>
		</>
	)
}

export default function IndividualApplicationPage({
	value,
	refresh,
}: {
	value: OkDocument<IndividualApplication>
	refresh: () => void
}) {
	const customEvaluationFlags: string[] = []
	if (value.data.attributes.phoneLocationDetails && value.data.attributes.address) {
		customEvaluationFlags.push(
			evaluateApplicationLocation(value.data.attributes.address, value.data.attributes.phoneLocationDetails, "Phone")
		)
	}

	if (value.data.attributes.ipLocationDetails && value.data.attributes.address) {
		customEvaluationFlags.push(
			evaluateApplicationLocation(value.data.attributes.address, value.data.attributes.ipLocationDetails, "IP")
		)
	}

	return (
		<IndividualApplicationInternal
			individual={value.data}
			documents={value.included?.filter(isApplicationDocument) || []}
			refresh={refresh}
			customEvaluationFlags={customEvaluationFlags}
			included={value.included}
		/>
	)
}
